import PropTypes from 'prop-types';

export const propTypes = {
    text: PropTypes.string,
    onToggle: PropTypes.func,
    isActive: PropTypes.bool,
    disabled: PropTypes.bool,
};
